var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.75V17H13.25V18.25H12H10.75V19.5H9.5H8.25V20.75H7H5.75V22H4.5H3.25H2V20.75V19.5H3.25V18.25V17H4.5V15.75V14.5H5.75V13.25V12H4.5V10.75H3.25V9.5H2V8.25V7H3.25H4.5H5.75H7H8.25V5.75H9.5V4.5V3.25H10.75V2H12H13.25V3.25H12V4.5V5.75V7V8.25V9.5V10.75V12V13.25V14.5V15.75ZM14.5 5.75H13.25V4.5V3.25H14.5V4.5V5.75ZM20.75 9.5V8.25H19.5H18.25H17H15.75H14.5V7V5.75H15.75V7H17H18.25H19.5H20.75H22V8.25V9.5H20.75ZM19.5 10.75V9.5H20.75V10.75H19.5ZM18.25 12V10.75H19.5V12H18.25ZM18.25 14.5H17V13.25V12H18.25V13.25V14.5ZM19.5 17H18.25V15.75V14.5H19.5V15.75V17ZM20.75 19.5H19.5V18.25V17H20.75V18.25V19.5ZM18.25 20.75H19.5H20.75V19.5H22V20.75V22H20.75H19.5H18.25V20.75ZM15.75 19.5H14.5H13.25V18.25H14.5H15.75V19.5ZM15.75 19.5V20.75H17H18.25V19.5H17H15.75Z",
    fill: "#FFBD3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarM);
export default __webpack_public_path__ + "static/media/star-m.5e987bfca65de601479640fcbdb0a6da.svg";
export { ForwardRef as ReactComponent };